import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fistcapitallatter',
  pure: false
})
export class FirstLatterCapitalPipe  implements PipeTransform { 
	transform(value:string): string {
		if(value){
		const first = value.substr(0,1).toUpperCase();
		return first + value.substr(1); 
		}
		return '';
	  }
}
